import authEndpoints from '../views/authorization/auth.endpoints.js';

const permissionsModule = {
    namespaced: true,
    state: () => ({
        institutionPermissions: [],
        intermediaryPermissions: {},
        intermediaryCustomizePermissions: {},
        systemPermissions: {},
        userPermissions: {},
        surveyPermissions: {},
        isSuperAdmin: false,
        signedInUser: {},
        landingPage: 'results',
        userTypes: {
            SuperAdmin: 'SuperAdmin',
            ProgramOfficer: 'ProgramOfficer',
            Intermediary: 'Intermediary',
            System: 'System',
            State: 'State',
            Institution: 'Institution'
        },
    }),
    mutations: {
        setSignedInUser(state, user) {
            state.signedInUser = user;
        },
        clearPermissions(state) {
            state.institutionPermissions = [];
            state.intermediaryPermissions = [];
            state.intermediaryCustomizePermissions = [];
            state.systemPermissions = [];
            state.userPermissions = [];
            state.surveyPermissions = [];
            state.isSuperAdmin = false;
            state.landingPage = 'results';
        },
        setIsSuperAdmin(state, isSuperAdmin) {
            state.isSuperAdmin = isSuperAdmin;
        },
        setUserPermissions(state, permissions) {
            state.institutionPermissions = permissions.find((p) => p.PermissionCode === 'Institution') || {};
            state.intermediaryPermissions = permissions.find((p) => p.PermissionCode === 'Intermediary') || {};
            state.intermediaryCustomizePermissions = permissions.find((p) => p.PermissionCode === 'IntermediaryCustomize' || {});
            state.systemPermissions = permissions.find((p) => p.PermissionCode === 'System') || {};
            state.userPermissions = permissions.find((p) => p.PermissionCode === 'User') || {};
            state.surveyPermissions = permissions.find((p) => p.PermissionCode === 'Survey') || {};
        },
        setLandingPage(state) {
            if (state.intermediaryPermissions.CanUpdate) {
                state.landingPage = 'intermediaries';
                return;
            }

            if (state.systemPermissions.CanUpdate) {
                state.landingPage = 'systems';
                return;
            }

            if (state.institutionPermissions.CanUpdate) {
                state.landingPage = 'institutions';
                return;
            }

            if (state.userPermissions.CanUpdate) {
                state.landingPage = 'users';
                return;
            }

            if (state.surveyPermissions.CanUpdate) {
                state.landingPage = 'users';
                return;
            }
        }
    },
    actions: {
        getPermissionsForUser({commit}) {
            return authEndpoints.getPermissionsForUser()
                .then((response) => {
                    commit('setIsSuperAdmin', response.IsSuperAdmin);
                    commit('setUserPermissions', response.Permissions);
                })
        }
    }
};

export default permissionsModule;
